export enum RequestState {
  Loading = "Loading",
  Success = "Success",
  Failure = "Failure",
}
